import React from 'react';

// SVG Inline
import SVG from 'react-inlinesvg';

import EmailSrc from 'assets/images/icons/DesignSysten2.0/comunication/e-mail.svg';
import ToSendSrc from 'assets/images/icons/DesignSysten2.0/comunication/Enviar.svg';
import HeadphoneSrc from 'assets/images/icons/DesignSysten2.0/comunication/Headphone.svg';
interface SVGInlineInterface {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const Email: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={EmailSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const Headphone: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={HeadphoneSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const ToSend: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={ToSendSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
